{
  "confirmInvalidateDescription": "Other farms will no longer be able to use this code to add this device to their account",
  "createDeviceShareCodeInstructions": "Set permissions for farms that will use this device.",
  "createDeviceShareCodeSuccessMessage": "Your share code has been created successfully.",
  "currentDeviceShareCode": "Current Code",
  "deviceOwnership": "Device Ownership",
  "deviceOwnershipLinkTo": "Ownership",
  "farmsBorrowingDeviceListEmpty": "No farms are currently borrowing this device.",
  "helpContent": "Devices can be shared with other farms by using a device share code. You can grant access to users outside your farm, and specify specific permissions for them while they use the device.",
  "invalidateButton": "Invalidate",
  "newDeviceShareCode": "New Device Share Code",
  "primaryOwnerLabel": "Primary Owner",
  "requestDeviceRemovalButton": "Remove Device",
  "requestDeviceRemovalDescription": "The device will be removed from this farm account.",
  "requestDeviceRemovalInstructions": "To continue, type the device alias.",
  "requestDeviceRemovalNote": "Note: This action will not affect billing",
  "requestDeviceRemovalTitle": "Request Device Removal",
  "requestRemovalALiasMustMatchErrorMessageWithCodaDeviceAlias": "Alias must match {{codaDeviceAlias}} exactly.",
  "shareDeviceShareCodeMessagePrefixWithCodeStrAndDeviceName": "Enter this code to gain access to FarmHQ device {{deviceName}}: {{codeStr}}",
  "shareTitlePrefixWithFarmName": "[FarmHQ]: Device Share Code from {{farmName}}"
}
